import React from 'react';
import Helpers from 'utils/helpers';
import './flexibleRow.css';

function FlexibleRow(props) {
  return (
    <div className={'flexible-row ' + (props.className || '')}>
      {props.children}
    </div>
  );
}

function FlexibleColumn(props) {
  const style = {
    width: props.width,
    maxWidth: props.maxWidth,
    minWidth: props.minWidth,
    ...props.style
  };

  return (
    <div className={'flexible-column ' + (props.className || '')} style={style}>
      {props.children}
    </div>
  );
}

function FlexibleStackable(props) {
  const style = {
    width: props.width,
    maxWidth: props.maxWidth,
    minWidth: props.minWidth,
    ...props.style
  };

  const getClass = () => {
    let classNames = ['flexible-stackable', props.className];
    if (props.at) {
      classNames.push(`flexible-stackable-at-${props.at}`);
    }
    if (Helpers.Object.exists(props.wrap)) {
      classNames.push('flex-wrap');
    }
    return Helpers.String.join(classNames);
  };

  return (
    <div className={getClass()} style={style}>
      {props.children}
    </div>
  );
}

FlexibleRow.Column = FlexibleColumn;
FlexibleRow.Stackable = FlexibleStackable;

export default FlexibleRow;